import React from 'react';
import { Col, Alert } from 'antd';
import { useTranslation } from 'react-i18next';

const ExternalDspInfo = ({ campaign }) => {
  const { t } = useTranslation();

  return (
    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="leftContainer">
      <h1>{t('Campaign payment')}</h1>
      <p>
        {t('info_payment_first')} (<strong>{campaign.external_dsp.name}</strong>){' '}
        {t('info_payment_second')}
      </p>
      <br />
      <Alert description={t('info_payment_third')} type="info" showIcon />
    </Col>
  );
};

export default ExternalDspInfo;
